var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"initial-loader-container"},[_c('i',{staticClass:"logo"},[_vm._v("Audiovisual Systems")])])
}]

export { render, staticRenderFns }